/*global _ newrelic */
MOVE.CalculatePageLoadTime = (function (MOVE) {

  var interval,
    previousEntries = 0;

  var init = function () {
    // Safari browser does not support performance object.
    if (window.performance && window.performance.getEntries !== "undefined" &&
      typeof window.performance.getEntries === "function") {
      // We assume that the page load (along with third party JS) is completed if there are no calls for
      // 2 seconds.
      interval = window.setInterval(getRdcEntries, 2000);
    }
  };

  var getRdcEntries = function getRdcEntries() {
    if (window.performance.getEntries().length === previousEntries) {
      window.clearInterval(interval);
      var lastEntry = _.last(window.performance.getEntries());
      // Sometimes, performance.getEntries just has the startTime and no responseEnd
      var fullPageLoadTimeInSeconds = Math.round(lastEntry.responseEnd || lastEntry.startTime);

      var t = window.performance.timing;

      var tmp = {
        'deviceLag': t.requestStart - t.navigationStart,
        'responseEnd': t.responseEnd - t.requestStart,
        'loadEventEnd': t.loadEventEnd - t.requestStart,
        "fullPageLoadTime": fullPageLoadTimeInSeconds,

        'pageType': window.MOVE_DATA.pageType,
        'isMobile': !!window.MOVE_DATA.isPhone
      };

      if (typeof newrelic === 'object') {
        newrelic.addPageAction(
          "Full Page Load", tmp
        );
      }
    } else {
      previousEntries = window.performance.getEntries().length;
    }
  };

  MOVE.CalculatePageLoadTime = {
    init: init
  };

  return MOVE.CalculatePageLoadTime;

})(MOVE || {});



// WEBPACK FOOTER //
// ./shared_critical/calculate_page_load_time.js